import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'lib-info-filled-icon',
  templateUrl: './lib-info-filled-icon.component.html',
  styles: [],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class LibInfoFilledIconComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
